import styled from 'react-emotion';
import { screenWidths } from '../utils/constants';

export const Title = styled.h1`
  font-family: ZeitungMicroPro-Bold;
  text-align: center;
  @media screen and (min-width: ${screenWidths.lg}px) {
    font-size: 30px;
    text-align: left;
    margin-bottom: 40px;
  }
`;

export const TitleMovil = styled.h1`
  font-family: ZeitungMicroPro-Bold;
  text-align: center;
  margin: 30px 0 30px;
  @media screen and (min-width: ${screenWidths.lg}px) {
    display:none;
    font-size: 2.5em;
    text-align: left;
    margin-bottom: 40px;
  }
`;

export const LightTitle = styled.h2`
  font-family: ZeitungMicroPro-Light;
  font-weight: normal;
  margin-bottom: 35px;
  font-size: 3em;
  @media screen and (min-width: ${screenWidths.lg}px) {
    font-size: 3.5em;
    text-align: left;
  }
`;

export const blueScrollbar = `
  overflow: scroll;
  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: var(--colors-image-border);
  }

  @media screen and (min-width: ${screenWidths.lg}px) {
    display: block;
  }
`;

const gridTwelveColContainerStyle = `
  width: 100%;
  @media screen and (min-width: ${screenWidths.lg}px) {
    display: grid;
    grid-template-columns: repeat(5, minmax(80px, 1fr)) repeat(7, 1fr);
    grid-column-gap: 10px;
    grid-row-gap: 50px;
    grid-auto-flow: dense;
  }
`;

const gridSidebarStyle = `
  grid-column: 1 / -1;
  @media screen and (min-width: ${screenWidths.lg}px) {
    grid-column: 1 / 5;
  }
`;

const gridContentStyle = `
  grid-column: 1 / -1;
  @media screen and (min-width: ${screenWidths.lg}px) {
    grid-column: 5 / -1;
  }
`;

export const grid = {
  container: gridTwelveColContainerStyle,
  left: gridSidebarStyle,
  right: gridContentStyle,
};

export const buttonWrapperStyle = `
  padding: 0;
  margin: 0;
  border: none;
  width: 100%;
  background: none;
  outline:none;
`

// export const onlyLgScreens = css`
//   display: none;
//   @media screen and (min-width: ${screenWidths.lg}px) {
//     display: block;
//   }
// `;


// WEBPACK FOOTER //
// ./src/components/Common.js